exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-af71da92]{opacity:.5}", ""]);

// exports
